
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import CDNVhostRepositoryInterface, { CDNVhostInterface } from '@/services/Vhost/CDN/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import XDNFeaturesForm, { countryActions, userAgents } from '@/services/Vhost/CDN/forms/XDNFeaturesForm';

@Component({
  mixins: [Themeable],
  inject: [
    'cdnVhostRepository',
  ],
})
export default class XDNFeaturesDialog extends Vue {
  @Prop() public readonly vhost!: CDNVhostInterface;

  public form: WPXFormValue<XDNFeaturesForm> = new WPXFormValue(XDNFeaturesForm);

  public visible = false;

  public missingConfig: boolean = false;

  public uAgents = userAgents;

  public cActions = countryActions;

  private cdnVhostRepository!: CDNVhostRepositoryInterface;

  public async created(): Promise<void> {
    await this.loadXDNFeatures();
    this.visible = true;
  }


  private async loadXDNFeatures(): Promise<void> {
    const xdnFeatures = await this.cdnVhostRepository.getXDNFeatures(this.vhost.websiteId);
    if (!xdnFeatures) {
      this.missingConfig = true;

      return;
    }

    xdnFeatures.cacheReferer = xdnFeatures.cacheReferer.filter((cr) => cr !== '');
    xdnFeatures.uaList = xdnFeatures.uaList.filter((ua) => ua !== '');
    xdnFeatures.countryBan = xdnFeatures.countryBan.filter((cb) => cb !== '');

    this.form.data.captcha = xdnFeatures.captcha;
    this.form.data.captchaLevel = xdnFeatures.captchaLevel;
    this.form.data.qsIgnore = xdnFeatures.qsIgnore;
    this.form.data.cacheReferer = xdnFeatures.cacheReferer.length ? xdnFeatures.cacheReferer : [];
    this.form.data.cacheBypass = xdnFeatures.cacheBypass;
    this.form.data.uaList = xdnFeatures.uaList.length ? xdnFeatures.uaList : [];
    this.form.data.countryBan = xdnFeatures.countryBan.length ? xdnFeatures.countryBan : [];
    this.form.data.countryAction = xdnFeatures.countryAction;
    this.form.data.countryHtAccess = xdnFeatures.countryHtAccess;
    this.missingConfig = false;
  }

  public async setXDNFeatures(): void {
    try {
      await this.cdnVhostRepository.setXDNFeatures(
          this.vhost.websiteId,
          {
            captcha: this.form.data.captcha,
            captchaLevel: this.form.data.captchaLevel,
            qsIgnore: this.form.data.qsIgnore,
            cacheReferer: this.form.data.cacheReferer,
            cacheBypass: this.form.data.cacheBypass,
            uaList: this.form.data.uaList,
            countryBan: this.form.data.countryBan,
            countryAction: this.form.data.countryAction,
            countryHtAccess: this.form.data.countryHtAccess,
          },
      );

      await this.$successDialog.show('XDN Features Enabled!');

      this.missingConfig = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  public async deleteXDNFeatures(): Promise<void> {
    try {
      await this.cdnVhostRepository.deleteXDNFeatures(this.vhost.websiteId);

      this.$successDialog.show('XDN Features Deleted!');

      await this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
